import { useCallback, useState } from 'react'
import { isEqual } from 'lodash'
import createSearchPanel, { FiltersType } from '../../../../containers/SearchPanel'
import { LightQuestionnaire } from '../../../../model/Questionnaire'
import { QuestionnaireListItem } from '../../../questionnaire'
import { BottomPanel } from '../BottomPanel'
import {
  QuestionnaireTemplateQueryFilters,
  SearchQuestionnaireBottomPanelProps,
} from './SearchQuestionnaireBottomPanel.model'
import { useGetInfiniteQuestionnaireTemplates } from '../../../../hooks/queries/questionnaireTemplates'
import { isVisibilityType, VisibilityType } from '../../../../constants'
import {
  useVisibilityOptions,
  VisibilityLabel,
} from '../../../../hooks/utils/visibilityFilters/useVisibilityOptions.hook'

const SearchPanel = createSearchPanel<LightQuestionnaire>()

export const SearchQuestionnaireBottomPanel = ({
  isUnmounting,
  onRequestClose,
  onSelect,
}: SearchQuestionnaireBottomPanelProps) => {
  const [queryFilters, setQueryFilters] = useState<QuestionnaireTemplateQueryFilters>({})
  const {
    query: { isLoading, fetchNextPage },
    questionnaireTemplateList: items,
    paginationState,
    cancelPendingQuery,
  } = useGetInfiniteQuestionnaireTemplates({ filters: queryFilters })

  const questionnairesVisibilityOptions = useVisibilityOptions(VisibilityLabel.Questionnaires)

  const handleFiltersChange = useCallback(
    (filters) => {
      const newQueryFilters: QuestionnaireTemplateQueryFilters = {
        ...(filters.search && { search: filters.search }),
        ...(filters.tagIds.length && { tagIds: filters.tagIds.join(',') }),
        ...(isVisibilityType(filters.visibility)
          ? filters.visibility !== VisibilityType.ALL && {
              private: filters.visibility === VisibilityType.PUBLIC ? 'false' : 'true',
            }
          : {
              userIds: filters.visibility,
            }),
      }

      if (!isEqual(queryFilters, newQueryFilters)) {
        cancelPendingQuery()
        setQueryFilters(newQueryFilters)
      }
    },
    [cancelPendingQuery, queryFilters],
  )

  const onPrimaryAction = (selectedItem?: LightQuestionnaire) => {
    if (selectedItem) {
      onSelect(selectedItem)
    }
  }

  return (
    <BottomPanel
      testId="questionnaire_template-search"
      title="Ajouter un modèle de questionnaire"
      isUnmounting={isUnmounting}
      onRequestClose={onRequestClose}
    >
      <SearchPanel
        items={items}
        loading={isLoading}
        itemCount={paginationState?.itemCount ?? null}
        pageCount={paginationState?.pageCount ?? null}
        currentPage={paginationState?.currentPage ?? 0}
        onPrimaryAction={onPrimaryAction}
        getItems={() => fetchNextPage()}
        onFiltersChange={handleFiltersChange}
        renderItem={(item) => <QuestionnaireListItem item={item} />}
        filterCapabilities={[FiltersType.Title, FiltersType.Visibility, FiltersType.Tags]}
        customVisibilityOptions={questionnairesVisibilityOptions}
        testId="questionnaire_template"
      />
    </BottomPanel>
  )
}
